import axios from 'axios';
import request from '../../lib/request';
import _ from 'lodash';

export function * uploadProfilePictureWithPresignedURL (profilePicture) {
  console.log('#uploadProfilePicture', profilePicture);
  const formdata = new FormData();

  console.log('#uploadProfilePicture, calling /aws/upload/file/image');

  const response = yield request.post('/aws/upload/file/image', {
    fileName: profilePicture.name,
    mimeType: profilePicture.type,
    fileUid: profilePicture.uid
  });

  console.log('#uploadProfilePicture, response: ', response);

  const { data: { signedUrlData } } = response;

  console.log('#uploadProfilePicture, signedUrlData: ', signedUrlData);

  // the key will be used to set the filename in s3 bucket
  formdata.append('key', signedUrlData.fields.key);
  formdata.append('file', profilePicture);

  try {
    console.log(profilePicture);
    console.log('#uploadProfilePicture, attempting to upload file object with preSignedUrl');
    yield axios.put(signedUrlData.signedUrl, profilePicture, {
      headers: { 'Content-Type': profilePicture.type, 'Content-Disposition': 'inline' }
    });

    console.log('#uploadProfilePicture, update the profile picture url using the result');

    // return uploaded image attributes
    return {
      url: signedUrlData.fields.path,
      key: signedUrlData.fields.key
    };
  } catch (err) {
    console.error('#uploadProfilePicture, Error, err:');
    console.error(err);
    console.error(err.stackTrace.toString());
  }
}

export const checkForUploadableHintFiles = (questionSet) => {
  // We will check through at most n=15 questions in the new / updated question set
  // If we find at least one hint that is other than a hyperlink (link) hint type
  // We will call the uploadHintFiles, otherwise we can assume that there are no
  // hints on this question set or the only hints are hyperlinks(links)
  console.log('#checkForUploadableHintFiles, questionSet: ', questionSet);
  let hintFileFound = false;

  try {
    console.log('#checkForUploadableHintFiles, try block');
    for (const questionObj of questionSet.questions) {
      console.log('#checkForUploadableHintFiles, question: ', questionObj);

      if (hintFileFound === true) { break; }

      if (!_.isEmpty(questionObj.hints)) {
        for (const hint of questionObj.hints) {
          console.log('#checkForUploadableHintFiles, hints: ', hint);
          // Gemini / API may use plain string hints; only object hints can be file uploads
          if (typeof hint !== 'object' || hint === null) {
            continue;
          }
          if (hint.type !== 'link' && hint.file?.originFileObj) {
            console.log('#checkForUploadableHintFiles, hint with file to upload found, setting flag and breaking from loop');
            hintFileFound = true;
            break;
          }
        }
      }
    }
    console.log(`#checkForUploadableHintFiles, hintFileFound flag: ${hintFileFound} `);
    return hintFileFound;
  } catch (err) {
    console.error('#checkForUploadableHintFiles, Error: ', err);
    throw err;
  }
};

// we check if there is a file and upload it and return the updated data with the url.
export const uploadHintFiles = async (questionSet) => {
  console.log('#uploadHintFiles', questionSet);
  const formdata = new FormData();

  console.log('#uploadHintFiles, formdata: ', formdata);

  for (let i = 0; i < questionSet.questions?.length; i++) {
    const question = questionSet.questions[i];
    console.log(`#uploadHintFiles, questions[${i}]: `, question);

    // since each question has an array of hints
    for (let j = 0; j < question.hints?.length; j++) {
      const hint = question.hints[j];
      console.log(`#uploadHintFiles, hint[${j}]: `, hint);

      // Plain-string hints (e.g. from AI) are not file uploads
      if (typeof hint !== 'object' || hint === null) {
        continue;
      }

      // we need this to check if the hint is a file and it actually exists
      if (hint.type !== 'link' && hint.file?.originFileObj) {
        console.log('#uploadHintFiles, calling /aws/upload/file/url');
        const response = await request.post('/aws/upload/file/url', {
          fileName: hint.file.name,
          mimeType: hint.file.type,
          fileUid: hint.file.uid
        });

        console.log('#uploadHintFiles, response: ', response);

        const { data: { signedUrlData } } = response;

        console.log('#uploadHintFiles, signedUrlData: ', signedUrlData);

        // the key will be used to set the filename in s3 bucket
        formdata.append('key', signedUrlData.fields.key);
        formdata.append('file', hint.file.originFileObj);

        console.log(`#uploadHintFiles, key: ${signedUrlData.fields.key}`);
        console.log(`#uploadHintFiles, file: ${hint.file.originFileObj}`);

        try {
          console.log('#uploadHintFiles, attempting to upload file object with preSignedUrl');
          await axios.put(signedUrlData.signedUrl, hint.file.originFileObj, {
            headers: { 'Content-Type': hint.file.originFileObj.type }
          });

          // update the hint url using the result
          console.log('#uploadHintFiles, update the hint url using the result');
          const updatedFile = {
            ...questionSet.questions[i].hints[j].file,
            url: signedUrlData.fields.path,
            keyPath: signedUrlData.fields.keyPath,
            originFileObj: undefined
          };

          console.log('#uploadHintFiles, updatedFile: ', updatedFile);
          questionSet.questions[i].hints[j].file = updatedFile;
        } catch (err) {
          console.error('#uploadHintFiles, Error, err:');
          console.error(err);
          console.error(err.stackTrace.toString());
        }
      }
    }
  }

  return questionSet;
};
